export default __webpack_public_path__ + "./images/zw.b60eb3eb.png";